["en","es","ko","ja","zh-Hans","zh-Hant","vi","id","th","zh-tw","pt-ao","km-kh"]